import { render, staticRenderFns } from "./Cn-TDS.vue?vue&type=template&id=e990ee8c&scoped=true&"
import script from "./Cn-TDS.vue?vue&type=script&lang=js&"
export * from "./Cn-TDS.vue?vue&type=script&lang=js&"
import style0 from "./Cn-TDS.vue?vue&type=style&index=0&id=e990ee8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e990ee8c",
  null
  
)

export default component.exports